import React, { useEffect, useState } from "react";

const PrepareTimer = ({ item }) => {
  const [time, setTime] = useState("-");

  useEffect(() => {
    const prepareLog = item.bookingLogs?.find(
      (log) => log.status === "prepare"
    );

    if (!prepareLog) {
      setTime("-");
      return;
    }

    const prepareTime = new Date(prepareLog.createdAt);

    if (item.status === "dispatch" && item.bookingdispatches?.length) {
      const dispatchTime = new Date(item.bookingdispatches[0].createdAt);
      setTime(calcDiff(prepareTime, dispatchTime));
      return;
    }

    const interval = setInterval(() => {
      setTime(calcDiff(prepareTime, new Date()));
    }, 1000);

    setTime(calcDiff(prepareTime, new Date()));

    return () => clearInterval(interval);
  }, [item.status, item.bookingLogs, item.bookingdispatches]);

  return <span>{time}</span>;
};

const pad = (num) => String(num).padStart(2, "0");

// helper
const calcDiff = (start, end) => {
    const diffMs = end - start;
    if (diffMs <= 0) return "00h 00m 00s";
  
    const totalSeconds = Math.floor(diffMs / 1000);
  
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

export default PrepareTimer; // ✅ IMPORTANT
